import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { CompetitionIndexComponent } from '../index/index.component'
import { CompetitionTeamCreateComponent } from './create/show.component'
import { CompetitionTeamMatchesTabComponent } from './matches-tab/show.component'
import { CompetitionTeamOverviewComponent } from './overview/show.component'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: CompetitionIndexComponent
  },
  {
    path: 'create',
    component: CompetitionTeamCreateComponent
  },
  {
    path: ':teamId/create',
    component: CompetitionTeamCreateComponent
  },
  {
    path: ':teamId',
    component: CompetitionTeamOverviewComponent,
    children: [
      {
        path: 'matches',
        component: CompetitionTeamMatchesTabComponent,
        pathMatch: 'full'
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompetitionTeamRoutingModule {}
